import React from 'react';
import styled from 'styled-components';

import InputSettingsField from './InputSettingsField';
import ButtonGroupSettings from './ButtonGroupSettings';
import Icon from '../../misc/Icon';

import ThemeIcons from '../../../theme/Icons';

const StyledWrapper = styled.div`

`;

const StyledFieldWrapper = styled.div`
  margin-bottom: 8px;
`;

const TooltipSettings = ({ tipVisible, tipTitle, tipDescription, onChange }) => {
  return (
    <StyledWrapper>
      <ButtonGroupSettings
        id="tooltip"
        types={[
          {
            type: 'true',
            icon: ThemeIcons.settings.display,
            active: tipVisible,
          },
          {
            type: 'false',
            icon: ThemeIcons.settings.hide,
            active: !tipVisible,
          }
        ]}
        onChange={(type) => onChange({ tipVisible: type === 'true' })}
      />
      <StyledFieldWrapper>
        <InputSettingsField
          id="tooltip"
          value={tipTitle}
          addonBefore={<Icon icon={ThemeIcons.settings.tooltipTitle} size="sm" />}
          type="text"
          onChange={(i, value) => onChange({ tipTitle: value })}
        />
      </StyledFieldWrapper>
      <StyledFieldWrapper>
        <InputSettingsField
          type="textarea"
          addonBefore={<Icon icon={ThemeIcons.settings.tooltipDescription} size="sm" />}
          value={tipDescription}
          onChange={(i, value) => onChange({ tipDescription: value })}
        />
      </StyledFieldWrapper>
    </StyledWrapper>
  );
};

export default TooltipSettings;
